import caterwaulTheme from '@liveauctioneers/caterwaul-components/lib/theme/theme';

/**
 * App-wide theme variables available in styled-components via <ThemeProvider />
 * @see https://styled-components.com/docs/advanced#theming
 */
export default caterwaulTheme;
